import React from 'react'
import Skeleton from 'src/common/ui-kit/Skeleton/Skeleton'

interface TokenSelectorSkeletonListProps {
  count?: number
}

const TokenSelectorSkeletonList: React.FC<TokenSelectorSkeletonListProps> = ({
  count = 18,
}) => {
  return (
    <div>
      <div className='flex flex-col gap-1'>
        {Array(count)
          .fill(0)
          .map((_, index) => (
            <div key={index} className='flex items-center px-2 py-0.5'>
              <Skeleton variant='circle' height={33} width={33} />
              <div className='ml-2'>
                <Skeleton
                  className='mt-1'
                  variant='circle'
                  height={15}
                  width={140}
                />
                <Skeleton
                  className='mb-1 mt-2'
                  variant='circle'
                  height={12}
                  width={100}
                />
              </div>
            </div>
          ))}
      </div>
    </div>
  )
}

export default TokenSelectorSkeletonList
